import firebase from '../Firebase/Firebase';

export const deleteMyAccount = async () => {
  const callable = firebase.app().functions('europe-west1').httpsCallable('deleteMyAccount');
  const result = await callable({});
  return result.data;
};
